module.exports = __webpack_public_path__ + "static/media/Apple iPad Air Silver.baec7bd6.png";